import { useCallback } from 'react';
import { ExtractRouteParams, generatePath, useHistory } from 'react-router';

export const useNavigate = () => {
  const history = useHistory();

  return useCallback(
    <S extends string>(url: S, params?: ExtractRouteParams<S>) => {
      history.push(generatePath(url, params));
    },
    [history],
  );
};
